// extracted by mini-css-extract-plugin
export default {"mainContainer":"Home_mainContainer__hXwn5"};